// CS group of the sales agents. They land on the quick-sale page.
export const ACQUISITION_GROUP = 'ATC - Acquisition';

// Temporary rollout: on top of the group, only these users see the quick-sale
// page. Empty the list to open it to the whole group.
export const QUICK_SALE_PILOT_USERS = ['marcela@foodforjoe.es'];

export function isAcquisitionAgent(authUser?: {
  cs_groups?: Array<{ name?: string }>;
}): boolean {
  return !!authUser?.cs_groups?.some(
    (group) => group?.name === ACQUISITION_GROUP
  );
}

export function canUseQuickSale(authUser?: {
  email?: string;
  cs_groups?: Array<{ name?: string }>;
}): boolean {
  if (!isAcquisitionAgent(authUser)) return false;
  if (QUICK_SALE_PILOT_USERS.length === 0) return true;
  return QUICK_SALE_PILOT_USERS.includes((authUser?.email || '').toLowerCase());
}
